import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHome12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconHome12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Home12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m6-.093.269.171 5.5 3.5a.5.5 0 0 1-.537.844L11 4.274V9.5A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5V4.274l-.231.148a.5.5 0 1 1-.537-.844l5.5-3.5zm0 1.186 4.044 2.573H10V9.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V3.666h-.044zm-1.623 5.03c-.048-.225-.022-.412.183-.638.16-.174.25-.195.258-.197s.025-.005.07.012a.6.6 0 0 1 .22.156l.005.005a1 1 0 0 0 1.522 0l.005-.005a.7.7 0 0 1 .22-.156c.046-.017.062-.014.07-.012s.1.023.258.197c.206.226.232.413.184.637-.062.286-.259.642-.581 1.032-.29.349-.628.664-.917.907a7.3 7.3 0 0 1-.916-.907c-.323-.39-.52-.746-.581-1.032m1.497-1.311s.156-.189.412-.34c.384-.227.995-.37 1.642.34 1.76 1.933-2.054 4.51-2.054 4.51s-3.813-2.577-2.053-4.51c.647-.71 1.257-.567 1.642-.34.256.151.411.34.411.34"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Home12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconHome12);
